import NextAuth from 'next-auth';

import type { NextAuthInstance } from '@blockworks/session';

import { baseAuthConfig } from '@/utils/auth/auth.config';

// For more information on each option (and a full list of options) go to
// https://next-auth.js.org/configuration/options
export const { handlers, auth, signIn, signOut }: NextAuthInstance = NextAuth(baseAuthConfig);
